import type { WidgetConfig } from '../lib/types';

interface HeaderProps {
  config: WidgetConfig;
  onClear: () => void;
  onClose: () => void;
}

export function Header({ config, onClear, onClose }: HeaderProps): preact.JSX.Element {
  return (
    <div class="yd-header">
      <div class="yd-header-title" onClick={onClose} style="cursor:pointer;display:flex;align-items:center;gap:8px;flex:1;min-width:0;">
        {config.logo_url && (
          <img class="yd-header-logo" src={config.logo_url} alt="" />
        )}
        <span class="yd-header-name">{config.name}</span>
      </div>
      <button class="yd-header-btn" onClick={onClose} title="Minimize">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </button>
      <button class="yd-header-btn" onClick={onClear} title="Clear conversation">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="1 4 1 10 7 10"/>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
        </svg>
      </button>
    </div>
  );
}
